import axios from "axios";
import { CorporateActionsType } from "@/models/stock-corporate-actions";
import { ListQueryParams } from "@/models/table";

// New typed corporate-actions grid (interface/api/corporate_actions). `data` must carry
// `company_id` (same resolution as the events tab) and may carry `families` (comma-separated
// family keys) plus `from_date` / `to_date` ISO dates.
export const getCorporateActionsList = async (params: ListQueryParams) => {
    const { page_size, page, filter_options, signal, data, next_page_url } = params;
    const { company_id, ...extraParams } = data ?? {};

    const url = next_page_url || `/interface/api/corporate_actions/company/${company_id}/list`;
    const defaultParams = next_page_url ? {} : { page_size, page, ...filter_options, ...extraParams };

    const res = await axios.get(url, {
        params: {
            ...defaultParams,
        },
        signal,
    });

    return res.data;
};

// Legacy v2 grid — still used by the custom-views library module ("stock-corporate-actions"
// in CustomViewsLibraryModules). The stock CORP ACTIONS tab now uses getCorporateActionsList.
export const getCorporateActions = async (params: ListQueryParams) => {
    const { page_size, page, filter_options, universe_id, data, next_page_url } = params;

    const url = next_page_url || `/API/v2/id/${universe_id}/corp_actions/list/all?&dgformat`;
    const defaultParams = next_page_url ? {} : { page_size, page, ...filter_options, ...data };

    const res = await axios.get(url, {
        params: {
            ...defaultParams,
        },
    });

    return res.data;
};

export const getCorporateActionsTypes = async (stockId: number) => {
    const res = await axios.get<CorporateActionsType[]>(`/API/v2/id/${stockId}/corp_actions/families`);

    return res.data;
};

export const getCorporateStockSplits = async (params: ListQueryParams) => {
    const { page_size, page, filter_options, data, next_page_url } = params;
    const tradingitem_id = data.tradingitem_id;

    const url = next_page_url || `/interface/api/tradingitem/${tradingitem_id}/splits/list`;
    const defaultParams = next_page_url ? {} : { page_size, page, ...filter_options };

    const res = await axios.get(url, {
        params: {
            ...defaultParams,
        },
    });

    return res.data;
};
